import(/* webpackMode: "eager", webpackExports: ["ExamResourceLayout"] */ "/vercel/path1/components/exam-resource-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExtendedFAQSection"] */ "/vercel/path1/components/extended-faq-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQAccordion"] */ "/vercel/path1/components/faq-accordion.tsx");
